import { get, post, postJson, deleteFun, upload, put } from '@/utils/request.js';
// 用户管理

/**
 * 用户登录
 * userName
 * password
 */
export function login(params) {
    return get('/mpp/user/login', params);
}

/**
 * 用户退出登录
 * userId
 */
export function logout(params) {
    return get('/mpp/user/logout', params);
}

/**
 * 用户信息
 */
export function getUserInfo(params) {
    return get('/mpp/user/getUserCache', params);
}

/**
 * 用户列表
 * pageNum
 * pageSize
 */
export function getUserList(params) {
	//return get('/mpp/user/findListFull', params);//太卡
	return get('/mpp/user/findList', params);
}

/**
 * 用户详情
 * id
 */
export function getUserById(params) {
    return get('/mpp/user/getFull', params);
}

/**
 * 新增用户
 * userName: '', //用户名
 * deptId: '', //部门
 * workNumber: '', //工号
 * postIds: '', //岗位
 * mppDept: {},
 * company: {},
 * roleIds: [],
 * status: 1
 * userPass: '', //密码
 * confirmPass: '',
 * userRealname: '', //真实姓名
 * userMobile: '', //手机号码
 * userTelephone: '', //用户电话
 * userEmail: '', //邮箱
 * companyId: '', //公司
 */
export function addUser(params) {
    return post('/mpp/user/add', params);
}

/**
 * 编辑用户
 *  userName: '', //用户名
 * deptId: '', //部门
 * workNumber: '', //工号
 * postIds: '', //岗位
 * mppDept: {},
 * company: {},
 * roleIds: [],
 * status: 1
 * userPass: '', //密码
 * confirmPass: '',
 * userRealname: '', //真实姓名
 * userMobile: '', //手机号码
 * userTelephone: '', //用户电话
 * userEmail: '', //邮箱
 * companyId: '', //公司
 */
export function editUser(params) {
    return post('/mpp/user/edit', params);
}

/**
 * 删除用户
 * ids: 用户id,支持批量删除
 */
export function deleteUser(params) {
    return deleteFun('/mpp/user/delete', params);
}

/**
 * 上传用户头像
 * file
 */
export function uploadAvatar(params) {
    return upload('/mpp/image/upload', params);
}


/**
 * 冻结/解冻用户积分
 * userId：用户Id
 * freezeFlag：1冻结中 0正常
 */
export function changeFreezeScore(params) {
    return postJson('/mpp/userfreezerecord/freezeScore', params)
}

/**
 * 冻结/解冻用户消费券
 * userId：用户Id
 * freezeFlag：1冻结中 0正常
 */
export function changeFreezeVoucher(params) {
    return postJson('/mpp/userfreezerecord/freezeVoucher', params)
}